mutation EditEmail($input: EditEmailInput!) {
  editEmail(input: $input)
}

